<template>
  <div :class="rootClasses" :style="rootStyles">
    <ElementControls
      v-if="editing"
      :no-page-break="!pageBreakAllowed"
      @delete="$emit('delete')"
      @page-break="$emit('page-break')"
      @duplicate="$emit('duplicate')"
    />
    <div class="submit-wrapper" :style="wrapperStyle">
      <div :id="item.id" />
    </div>
  </div>
</template>

<script>
import ElementControls from "../element-controls.vue";
import commonStyles from "../mixins/commonStyles";
import set from "lodash/set";
import { addScriptToPage } from "@/helpers/utils";

export default {
  name: "Recaptcha",
  components: {
    ElementControls,
  },
  mixins: [commonStyles],
  props: {
    item: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  emits: ["delete", "page-break", "duplicate", "verified", "expired", "error"],
  computed: {
    sitekey() {
      switch (process.env.NODE_ENV) {
        case "production":
          return "6Ldh1iIeAAAAALUMMzNiyGFE9ww8fYnMPj3GNt5B";
        default:
          return "6LcVWiIeAAAAAFDWXMfvi2p1SgFKD6iPUOd9VK3s";
      }
    },
    wrapperStyle() {
      return {
        "justify-content": this.itemStyling.alignment || "left",
      };
    },
  },
  mounted() {
    // inject recaptcha script
    window.onRecaptchaLoadCallback = this.render;
    addScriptToPage(
      "https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoadCallback&render=explicit",
    );
  },
  methods: {
    render() {
      if (window.grecaptcha && window.grecaptcha.render) {
        window.grecaptcha.render(this.item.id, {
          sitekey: this.sitekey,
          size: "normal",
          callback: (res) => {
            set(this.item, "value", res);
            this.$emit("verified");
          },
          "expired-callback": () => {
            this.$emit("expired");
          },
          "error-callback": () => {
            this.$emit("error");
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.submit-wrapper {
  border-radius: 8px;
}
</style>
